export default __webpack_public_path__ + "static/media/form-name-golden.f6ddc7ed.svg";